import S3FileUpload from "./S3FileUpload";
import { S3FileUploadProps } from "./types";
import { SelectedFile } from "../../types/project";

export default S3FileUpload;
export type { S3FileUploadProps, SelectedFile };